// extracted by mini-css-extract-plugin
module.exports = {"ClearBoard":"ClearBoard_ClearBoard__3xOXS","Confirm":"ClearBoard_Confirm__1ZJLX","Cancel":"ClearBoard_Cancel__3f_jf"};